import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const BranchesList = lazy(() =>
  import("../../container/branches/BranchesList")
);
const AddBranch = lazy(() =>
  import("../../container/branches/components/createBranchForm")
);
const BranchDetails = lazy(() =>
  import("../../container/branches/components/BranchDetails")
);

function IconsRoute() {
  return (
    <Routes>
      <Route path="/" element={<BranchesList />} />
      <Route path="/add-branch" element={<AddBranch />} />
      <Route path="/:id/info" element={<BranchDetails />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
